module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "advice-table"
  }, [_c('HeadFixedTable', {
    attrs: {
      "columns": _vm.currentColumns,
      "checkbox": _vm.hasCheckbox,
      "check_all": _vm.hasCheckbox,
      "checkbox_length": 1000,
      "isAllChecked": _vm.isAllChecked,
      "hasPagination": true,
      "list": _vm.currentList
    },
    on: {
      "pageChange": _vm.pageChange
    },
    scopedSlots: {
      "delete-td": function(props) {
        return [_vm._t("delete", null, {
          item: props.item
        })]
      },
      "status-td": function(props) {
        return [_vm._t("status", null, {
          item: props.item
        })]
      }
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-756841ca", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-756841ca!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/web/pause_advice_table.vue
// module id = 772
// module chunks = 0